import React from "react";
import LearnMore from "../../../../components/learnMore/learnMore";

// eslint-disable-next-line react/prop-types
const UtilizationLearnMore = ({ sourceType }) => {
  return (
    <LearnMore
      title="Class Utilization"
      learnMoreId="utilizationLearnMore"
      content={getContent(sourceType)}
      html
    />
  );
};

const getContent = (sourceType = "") => {
  if (sourceType === "clubready") {
    return clubreadyText;
  } else {
    if (sourceType === "mindbody") {
      return mindbodyText;
    }
  }

  return otherText;
};

const clubreadyText = `
    <b>Category:</b> There are a few different ways to see the data based on the other filters.<br />
      1. Utilization - We take the capacity of your class and divide by the amount used to get you a percentage used.<br />
      2. Average Class Size - Count of the number of completed visits and divide by the number of classes. <br />
      3. Number of Clients – Adding up all the completed visits<br /><br />
    
    <b>Type:</b> Virtual or Physical. If your business management system as the ability to send us your class data separated by virtual or physical, we will be able to use this filter. <br /><br />
    
    <b>Classes:</b>  This filter will show you all of the classes by name that are available. <br /><br />
    
    <b>Staff:</b>  All instructors who taught a class will be listed by last name.<br /><br />
    
    <b>Date Range:</b>  This dropdown has all of our pre-determined date ranges for a quick search. <br /><br />
    
    <b>Date:</b>  You have the ability to search any start and end date.<br /><br />
    
    
    <i>All green/red smaller percentages next to the numbers are the change compared to the previous period. 
    The previous period is looking back at the same number of days you are seeing in the calendar control. 
    If your dates allow for 26 days, the 26 days preceding your start date would be the previous period
     Green is a positive change while red is a negative.</i><br/><br/>
     
    <b>Total (Utilization, Average Class Size and Number of Clients):</b> Depending on which category you selected, 
    this will give you the total for the time frame and filters. <br/><br/>
    
    From there we will breakdown the percentage or number of the completed visits belong to each of these seven groupings;<br/><br/>
    
    <b>Members:</b> Every membership visit would show here. Unless the very first visit was on a membership package, then that first visit would show in First Time.<br/><br/>
    <b>First Time:</b> Only the very first visit by a client will show in this section. Regardless of membership status or intro package. ClassPass first visits are excluded from here<br/><br/>
    <b>Intro Offers:</b> All visits that are attributed to an intro offer tagged in iKizmet. The only exception would be a clients very first visit. That will always show in the First Time category.<br/><br/>
    <b>Packages:</b>Visits that are covered by a non-membership package that iKizmet is counting as a conversion/enrollment. This will be based on brand level mapping.<br/><br/>
    <b>ClassPass:</b>If the visitor is coming to class via ClassPass, all of their visits will show here.<br/><br/> 
    <b>Cross Club:</b>Any visit by a member from another studio within the brand (<i>ClubReady ONLY</i>)<br/><br/> 
    <b>Other:</b> All other visits fall under this category. <br/><br/>
      
    Note – When looking at the Utilization category (percentages), the seven groupings will add up to 100% and not add up 
    to the percentage shows in Total. The percentages of the seven groupings are showing the number of completed visits 
    and <b><u>not</u></b> including unused spots.<br/><br/>
    
    <b>Total Breakdown:</b> This section gives you the ability to see the data by day, week, month or year. 
    This also is where you can get to some raw data on your classes.<br/><br/>
    
    <b>Utilization Heatmap:</b> Each bubble is a representation of the time a class (and workshops) was on your calendar. 
    Every time slot that is on your schedule for the time period will be shown. The darker the block the lower 
    the performance is of whatever service (or service provider) that was held within that operating window. 
    The brighter the block, the better the performance. Click on each bubble to bring up the details on that time slot.<br/><br/>
    
    When you switch the toggle to “Group by Day of the Week”, you will only see the day of week total and no longer see the time slots.

`;

const mindbodyText = `
    <b>Category:</b> There are a few different ways to see the data based on the other filters.<br />
      1. Utilization - We take the capacity of your class and divide by the amount used to get you a percentage used.<br />
      2. Average Class Size - Count of the number of completed visits and divide by the number of classes. <br />
      3. Number of Clients – Adding up all the completed visits<br /><br />
      4. Average Revenue – Count average revenue by visits<br /><br />
    
    <b>Type:</b> Virtual or Physical. If your business management system as the ability to send us your class data separated by virtual or physical, we will be able to use this filter. <br /><br />
    
    <b>Classes:</b>  This filter will show you all of the classes by name that are available. <br /><br />
    
    <b>Staff:</b>  All instructors who taught a class will be listed by last name.<br /><br />
    
    <b>Date Range:</b>  This dropdown has all of our pre-determined date ranges for a quick search. <br /><br />
    
    <b>Date:</b>  You have the ability to search any start and end date.<br /><br />
    
    <i>All green/red smaller percentages next to the numbers are the change compared to the previous period. 
    The previous period is looking back at the same number of days you are seeing in the calendar control. 
    If your dates allow for 26 days, the 26 days preceding your start date would be the previous period
     Green is a positive change while red is a negative.</i><br/><br/>
     
    <b>Total (Utilization, Average Class Size and Number of Clients):</b> Depending on which category you selected, 
    this will give you the total for the time frame and filters. <br/><br/>
    
    From there we will breakdown the percentage or number of the completed visits belong to each of these six groupings;<br/><br/>
    
    <b>ClassPass:</b> If the visitor is coming to class via ClassPass, all of their visits will show here. <br/><br/> 
    <b>First Time:</b> Only the very first visit by a client will show in this section. Regardless of membership status or intro package. ClassPass first visits are excluded from here. <br/><br/>
    <b>Membership:</b> Every membership visit would show here. Unless the very first visit was on a membership package, then that first visit would show in First Time.<br/><br/>
    <b>Intro Offers:</b> All visits that are attributed to an intro offer tagged in iKizmet. The only exception would be a clients very first visit. That will always show in the First Time category.<br/><br/>
    <b>Packages:</b> Visits that are covered by a non-membership package that iKizmet is counting as a conversion/enrollment. This will be based on brand level mapping.  <br/><br/>
    <b>Other:</b> All other visits fall under this category. <br/><br/>
      
    Note – When looking at the Utilization category (percentages), the six groupings will add up to 100% and not add up 
    to the percentage shows in Total. The percentages of the six groupings are showing the number of completed visits 
    and <b><u>not</u></b> including unused spots.<br/><br/>
    
    <b>Total Breakdown:</b> This section gives you the ability to see the data by day, week, month or year. 
    This also is where you can get to some raw data on your classes.<br/><br/>
    
    <b>Utilization Heatmap:</b> Each bubble is a representation of the time a class (and workshops) was on your calendar. 
    Every time slot that is on your schedule for the time period will be shown. The darker the block the lower 
    the performance is of whatever service (or service provider) that was held within that operating window. 
    The brighter the block, the better the performance. Click on each bubble to bring up the details on that time slot.<br/><br/>
    
    When you switch the toggle to “Group by Day of the Week”, you will only see the day of week total and no longer see the time slots.
`;

const otherText = `
    <b>Category:</b> There are a few different ways to see the data based on the other filters.<br />
      1. Utilization - We take the capacity of your class and divide by the amount used to get you a percentage used.<br />
      2. Average Class Size - Count of the number of completed visits and divide by the number of classes. <br />
      3. Number of Clients – Adding up all the completed visits<br /><br />
    
    <b>Type:</b> Virtual or Physical. If your business management system as the ability to send us your class data separated by virtual or physical, we will be able to use this filter. <br /><br />
    
    <b>Classes:</b>  This filter will show you all of the classes by name that are available. <br /><br />
    
    <b>Staff:</b>  All instructors who taught a class will be listed by last name.<br /><br />
    
    <b>Date Range:</b>  This dropdown has all of our pre-determined date ranges for a quick search. <br /><br />
    
    <b>Date:</b>  You have the ability to search any start and end date.<br /><br />
    
    <i>All green/red smaller percentages next to the numbers are the change compared to the previous period. 
    The previous period is looking back at the same number of days you are seeing in the calendar control. 
    If your dates allow for 26 days, the 26 days preceding your start date would be the previous period
     Green is a positive change while red is a negative.</i><br/><br/>
     
     <b>Total (Utilization, Average Class Size and Number of Clients):</b> Depending on which category you selected, 
     this will give you the total for the time frame and filters. <br/><br/>
          
     <b>Utilization Heatmap:</b> Each bubble is a representation of the time a class (and workshops) was on your calendar. 
     Every time slot that is on your schedule for the time period will be shown. The darker the block the lower 
     the performance is of whatever service (or service provider) that was held within that operating window. 
     The brighter the block, the better the performance. Click on each bubble to bring up the details on that time slot.<br/><br/>
`;

export default UtilizationLearnMore;
